import { Component, OnInit } from '@angular/core';
import { LogService } from '../_shared/log.service';

@Component({
  selector: 'app-employer',
  templateUrl: './employer.component.html',
  styleUrls: ['./employer.component.less']
})
export class EmployerComponent implements OnInit {

  constructor(private eventService: LogService) { }

  public routeVal = '';
  receiveVal($event){
    this.routeVal = $event;
  }

  public newData = ''
  ngOnInit(): void {
    this.eventService.on<string>().subscribe(
      data => {
        this.newData = data
        this.routeVal = this.newData
        console.log(this.newData +"final")
      }
    )
  }

}
